import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DossierRemboursement } from '@features/mes-remboursements/models/dossier-remboursement.model';
import { PaginatedResponse } from '@shared/components/model/paginated-response.model';
import { RemboursementRechercheRequest } from '@features/mes-remboursements/features/mes-remboursements-recherche/models/remboursement-recherche-request';
import { MesRemboursementsConfig } from '@features/mes-remboursements/config/mes-remboursements.config';
import { RemboursementRechercheExportRequest } from '../features/mes-remboursements-recherche/models/remboursement-recherche-export-request';
import { DestinatairePaiement } from '@features/mes-remboursements/models/destinataire-paiement.model';

@Injectable({
  providedIn: 'root',
})
export class MesRemboursementsService {
  constructor(private readonly httpClient: HttpClient) { }

  getDossiers(
    query: RemboursementRechercheRequest,
  ): Observable<PaginatedResponse<DossierRemboursement>> {
    return this.httpClient.post<PaginatedResponse<DossierRemboursement>>(
      MesRemboursementsConfig.listeDossiers,
      query,
    );
  }

  getDossiersExport(query: RemboursementRechercheExportRequest): Observable<HttpResponse<Blob>> {
    return this.httpClient.post(
      MesRemboursementsConfig.listeDossiersExport,
      query,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  putDestinatairePaiement(payload: DestinatairePaiement): Observable<void> {
    return this.httpClient.put<void>(MesRemboursementsConfig.putDestinatairePaiement, payload);
  }
}
